import { render, staticRenderFns } from "./OptimizationView.vue?vue&type=template&id=aaa44646"
import script from "./OptimizationView.vue?vue&type=script&lang=js"
export * from "./OptimizationView.vue?vue&type=script&lang=js"
import style0 from "./OptimizationView.vue?vue&type=style&index=0&id=aaa44646&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports